import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";
import {
  ApiService,
  Region,
} from "@core/services/api/api.service";
import { AuditPermissionService } from "@core/services/audit-permission.service";
import { ModalComponent } from "@shared/components/modal/modal.component";
import { SuccessComponent } from "@shared/components/success/success.component";
import { ToastMessageComponent } from "@shared/components/toast-message/toast-message.component";

@Component({
  selector: "app-add-country",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrimeNGSharedModule,
    ModalComponent,
    ToastMessageComponent,
  ],
  templateUrl: "./add-country.component.html",
  styleUrl: "./add-country.component.scss",
})
export class AddCountryComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() editMode: boolean = false;
  @Input() data: any;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();
  permissionPop: boolean = false;
  @ViewChild(ToastMessageComponent) toast!: ToastMessageComponent;

  filterRegions: Region[] = [];
  countryForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private auditService: AuditPermissionService
  ) {
    this.initializeForm();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.editMode) {
      this.countryForm.patchValue({
        country: this.data.name,
        region: this.data.region,
      });
    }
  }
  ngOnInit(): void {
    this.getRegion();
  }
  initializeForm(): void {
    this.countryForm = this.fb.group({
      region: [null, Validators.required],
      country: [null, Validators.required],
    });
  }
  close() {
    this.closeDialog.emit();
    this.permissionPop = false;
    this.countryForm.reset();
  }
  addCountry() {
    const formValue = this.countryForm.value;
    const payload = {
      name: formValue.country,
      region_id: formValue.region.id,
    };
    this.auditService.addCountry(payload).subscribe({
      next: (res) => {
        this.toast.showSuccess("success", res.message);
        this.closeDialog.emit();
        this.countryForm.reset();
      },
      error: (error) => {
        // this.toast.showError("error", error);
      },
    });
  }
  updateCountry() {
    const formValue = this.countryForm.value;
    const payload = {
      name: formValue.country,
      region_id: formValue.region.id,
    };
    this.auditService.updateCountry(this.data.id, payload).subscribe({
      next: (res) => {
        this.toast.showSuccess("success", res.message);
        this.closeDialog.emit();
        this.countryForm.reset();
      },
      error: (error) => {
        // this.toast.showError("error", error);
      },
    });
  }
  onSubmit() {
    this.permissionPop = true;
  }
  getRegion() {
    this.apiService.getRegions().subscribe({
      next: (response) => {
        this.filterRegions = response.regions;
      },
      error: (err) => {},
    });
  }
  onSubmitPermission(event: any) {
    if (this.editMode) {
      this.updateCountry();
    } else {
      this.addCountry();
    }

    this.permissionPop = false;
  }
  onCancelPermission(event: any) {
    this.permissionPop = false;
  }
}
